export const blockClass = 'efi-data-table';

export const PERF_MARKS = {
  INIT_START: 'ftd:init-start',
  REACT_MOUNTED: 'ftd:react-mounted',
  FIRST_CHUNK_RECEIVED: 'ftd:first-chunk-received',
  FIRST_CHUNK_TRANSFORMED: 'ftd:first-chunk-transformed',
  FIRST_DATA_PAINT: 'ftd:first-data-paint',
  ALL_DATA_LOADED: 'ftd:all-data-loaded',
};

export const PERF_MEASURES = {
  FIRST_CHUNK_PARSE: 'ftd:first-chunk-parse',
  FIRST_CHUNK_TRANSFORM: 'ftd:first-chunk-transform',
  FIRST_PAGE_RENDER: 'ftd:first-page-render',
  TOTAL_TO_FIRST_PAGE: 'ftd:total-to-first-page',
  TOTAL_FULL_LOAD: 'ftd:total-full-load',
};
